import { useMediaPredicate } from 'react-media-hook';

export const minDesktopWidthPx = 1350;

export enum ScreenBreakpoint {
    TABLET = '(min-width: 1000px)',
    DESKTOP = `(min-width: 1260px)`, // minDesktopWidthPx (because not allowed to compute in enum)
    MAX_POCKET = '(max-width: 980px)',
    MAX_MOBILE = '(max-width: 620px)',
}

export default function useScreenBreakpoint(breakpoint: ScreenBreakpoint | string) {
    return useMediaPredicate(breakpoint);
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('useScreenBreakpoint', async () => {
        it('todo', () => {});
    });
}

// #endregion
